module.exports = __webpack_public_path__ + "img/android.c74e4647.svg";